export function parseUsernameFromEmail(email?: string) {
  return email?.split('@')[0];
}
